import { getRefundAdminGuidance, getRefundStatusLabelForCode } from "./getRefundAdminGuidance";
import {
  getChangeAdminGuidance,
  getChangeStatusLabelForCode,
} from "./getChangeAdminGuidance";
import {
  getVoidAdminGuidance,
  getVoidStatusLabelForCode,
} from "./getVoidAdminGuidance";

export function getStatusName(val) {
  switch (val) {
    case "TicketCancelationRequested":
      return "Awaiting Cancellation";
    case "PendingVoid":
      return "Awaiting Void";
    default:
      return getGeneralStatus(val);
  }
}

export function getChangeStatusName(val, data) {
  if (data) {
    return getChangeAdminGuidance(data).statusLabel;
  }
  const fromCode = getChangeStatusLabelForCode(val);
  if (fromCode) return fromCode;
  switch (val) {
    case "OPEN_TICKET_VALIDATION_FAILED":
    case "OpenTicketValidationFailed":
      return "Could not start";
    case "OPEN_TICKET_NOT_ELIGIBLE":
    case "OpenTicketNotEligible":
      return "Not eligible";
    case "OPEN_TICKET_PROCESSING_FAILED":
    case "OpenTicketProcessingFailed":
      return "Could not finish — try again";
    case "AdditionalInformationRequired":
    case "ADDITIONAL_INFORMATION_REQUIRED":
    case "OpenTicketAdditionalInformationRequired":
    case "OPEN_TICKET_ADDITIONAL_INFORMATION_REQUIRED":
      return "Need more information";
    case "OPEN_TICKET_DECLINED_BY_SUPPLIER":
    case "OpenTicketDeclinedBySupplier":
      return "Airline declined open ticket";
    case "ManualOpenTicketProcessing":
    case "MANUAL_OPEN_TICKET_PROCESSING":
      return "Check airline if it can open";
    case "OpenTicketProcessingWithSupplier":
    case "OPEN_TICKET_PROCESSING_WITH_SUPPLIER":
      return "Working with the airline";
    case "OpenTicketSuccessful":
    case "OPEN_TICKET_SUCCESSFUL":
      return "Ticket is OPEN";
    case "OpenTicketCompleted":
    case "OPEN_TICKET_COMPLETED":
      return "Completed";
    case "OpenTicketRequestSubmitted":
    case "OPEN_TICKET_REQUEST_SUBMITTED":
      return "Request received — Ops review";
    case "OpenTicketRequestCanceled":
    case "OPEN_TICKET_REQUEST_CANCELED":
    case "OpenTicketRequestCancelled":
    case "OPEN_TICKET_REQUEST_CANCELLED":
      return "Cancelled";
    case "NameChangeRequestSubmitted":
    case "NAME_CHANGE_REQUEST_SUBMITTED":
      return "Review this request";
    case "ManualNameChangeProcessing":
    case "MANUAL_NAME_CHANGE_PROCESSING":
      // Backend often keeps this status after quote; with `data`, guidance
      // maps needs_quote → "Check airline for price" / awaiting_payment → "Waiting for agent to pay"
      return "Check airline for price";
    case "NameChangeQuoted":
    case "NAME_CHANGE_QUOTED":
      return "Waiting for agent to pay";
    case "NameChangePaymentRequired":
    case "NAME_CHANGE_PAYMENT_REQUIRED":
      return "Agent must pay";
    case "NameChangePaymentAuthorised":
    case "NAME_CHANGE_PAYMENT_AUTHORISED":
    case "NameChangePaymentAuthorized":
    case "NAME_CHANGE_PAYMENT_AUTHORIZED":
      return "Paid — send to airline";
    case "NameChangeSubmittedToSupplier":
    case "NAME_CHANGE_SUBMITTED_TO_SUPPLIER":
      return "Waiting on airline";
    case "NameChangeCompleted":
    case "NAME_CHANGE_COMPLETED":
      return "Completed";
    case "NameChangeFailed":
    case "NAME_CHANGE_FAILED":
      return "Failed — check next step";
    case "DateChangeRequestDenied":
    case "DATE_CHANGE_REQUEST_DENIED":
      return "Declined by Ops";
    case "NameChangeRequestDenied":
    case "NAME_CHANGE_REQUEST_DENIED":
      return "Declined by Ops";
    case "NameChangeRequestCanceled":
    case "NAME_CHANGE_REQUEST_CANCELED":
    case "NameChangeRequestCancelled":
    case "NAME_CHANGE_REQUEST_CANCELLED":
      return "Agent withdrew";
    case "DateChangeRequestCanceled":
    case "DATE_CHANGE_REQUEST_CANCELED":
    case "DateChangeRequestCancelled":
    case "DATE_CHANGE_REQUEST_CANCELLED":
      return "Agent withdrew";
    case "NameChangeQuoteExpired":
    case "NAME_CHANGE_QUOTE_EXPIRED":
    case "DateChangeQuoteExpired":
    case "DATE_CHANGE_QUOTE_EXPIRED":
      return "Quote expired";
    default:
      return getGeneralStatus(val);
  }
}
export function getVoidStatusName(val, data) {
  if (data) {
    return getVoidAdminGuidance(data).statusLabel;
  }
  const fromCode = getVoidStatusLabelForCode(val);
  if (fromCode) return fromCode;
  switch (val) {
    case "Pending":
    case "PendingVoid":
    case "ManualReviewRequired":
    case "MANUAL_REVIEW_REQUIRED":
      return "Ops must review this void";
    case "AUTO_VOID_FAILED":
    case "AutoVoidFailed":
      return "Send failed — void it on airline site";
    case "VOID_REQUEST_SUBMITTED":
    case "VoidRequestSubmitted":
      return "Request received";
    case "Approved":
    case "MANUAL_VOID_PROCESSING":
    case "ManualVoidProcessing":
      return "Void it on the airline site";
    case "AUTO_VOID_PROCESSING":
    case "AutoVoidProcessing":
    case "VOID_PROCESSING":
      return "Sending to airline";
    case "SUBMITTED_TO_SUPPLIER":
    case "SubmittedToSupplier":
    case "SUPPLIER_PROCESSING":
    case "SupplierProcessing":
      return "Waiting on airline";
    case "VOID_SUCCESSFUL":
    case "VoidSuccessful":
      return "Airline voided — settle money";
    case "SETTLEMENT_PENDING":
    case "SettlementPending":
      return "Settling money";
    case "SERVICE_FEE_DEBITED":
    case "ServiceFeeDebited":
      return "Fee taken — credit balance";
    case "BALANCE_REFUNDED":
    case "BalanceRefunded":
      return "Balance credited";
    case "SETTLEMENT_FAILED":
    case "SettlementFailed":
      return "Airline done — money failed";
    case "VOID_FAILED_BY_SUPPLIER":
    case "VoidFailedBySupplier":
      return "Airline could not void it";
    case "VOID_DECLINED_BY_SUPPLIER":
    case "VoidDeclinedBySupplier":
      return "Airline declined void";
    case "VOID_FAILURE_SETTLED":
    case "VoidFailureSettled":
      return "Auto submission failed";
    case "VOID_REQUEST_VALIDATION_FAILED":
    case "VoidRequestValidationFailed":
      return "Could not start";
    case "VOID_REQUEST_DENIED":
    case "VoidRequestDenied":
    case "Denied":
    case "Rejected":
      return "Declined by Ops";
    case "VOID_REQUEST_CANCELED":
    case "VoidRequestCanceled":
    case "VOID_REQUEST_CANCELLED":
    case "VoidRequestCancelled":
      return "Agent withdrew";
    case "VOID_COMPLETED":
    case "VoidCompleted":
    case "Success":
      return "Completed";
    default:
      return getGeneralStatus(val);
  }
}

export function getRefundStatusName(val, data) {
  if (data) {
    return getRefundAdminGuidance(data).statusLabel;
  }
  const fromCode = getRefundStatusLabelForCode(val);
  if (fromCode) return fromCode;
  switch (val) {
    case "Pending":
      return "Ops must review this refund";
    case "ManualReviewRequired":
    case "MANUAL_REVIEW_REQUIRED":
      return "Ops must review this refund";
    case "AUTO_REFUND_FAILED":
    case "AutoRefundFailed":
      return "Price failed — get airline numbers";
    case "ManualRefundProcessing":
    case "MANUAL_REFUND_PROCESSING":
      return "Get price — then enter quote";
    case "RefundQuoted":
    case "REFUND_QUOTED":
      return "Waiting for agent to accept quote";
    case "REFUND_QUOTE_EXPIRED":
    case "RefundQuoteExpired":
      return "Quote expired — quote again";
    case "RefundAccepted":
    case "REFUND_ACCEPTED":
      return "Submit refund on airline site";
    case "Approved":
      return "Get price — then enter quote";
    case "AUTO_REFUND_SUBMISSION_FAILED":
    case "AutoRefundSubmissionFailed":
      return "Send failed — submit on airline site";
    case "AUTO_REFUND_PROCESSING":
    case "AutoRefundProcessing":
      return "Ops must review this refund";
    case "REFUND_REQUEST_SUBMITTED":
    case "RefundRequestSubmitted":
      return "Getting supplier price";
    case "REFUND_SUBMITTING":
    case "RefundSubmitting":
    case "AUTO_REFUND_SUBMISSION":
    case "AutoRefundSubmission":
      return "Sending to airline";
    case "SupplierProcessing":
    case "SUPPLIER_PROCESSING":
    case "SUBMITTED_TO_SUPPLIER":
    case "SubmittedToSupplier":
      return "Waiting on airline";
    case "PendingRefund":
    case "REFUND_SUCCESSFUL":
    case "RefundSuccessful":
      return "Airline refunded — credit wallet";
    case "SETTLEMENT_PENDING":
    case "SettlementPending":
      return "Settling money";
    case "REFUND_CREDITED":
    case "RefundCredited":
      return "Wallet credited";
    case "SETTLEMENT_FAILED":
    case "SettlementFailed":
      return "Airline done — money failed";
    case "Failed":
    case "REFUND_FAILED_BY_SUPPLIER":
    case "RefundFailedBySupplier":
      return "Airline could not refund it";
    case "REFUND_DECLINED_BY_SUPPLIER":
    case "RefundDeclinedBySupplier":
      return "Airline declined refund";
    case "REFUND_DECLINED_BY_AGENT":
    case "RefundDeclinedByAgent":
      return "Agent declined";
    case "REFUND_VALIDATION_FAILED":
    case "RefundValidationFailed":
      return "Could not start";
    case "RefundCompleted":
    case "REFUND_COMPLETED":
      return "Completed";
    default:
      return getGeneralStatus(val);
  }
}

export function getGeneralStatus(status) {
  switch (status) {
    case "PendingChange":
    case "PendingVoid":
    case "PendingRefund":
    case "PendingReissue":
      return "Pending change from airline";
    case "ManualReviewRequired":
    case "MANUAL_REVIEW_REQUIRED":
      return "Review this request";
    case "ManualRefundProcessing":
    case "MANUAL_REFUND_PROCESSING":
      return "Create quote";
    case "RefundQuoted":
    case "REFUND_QUOTED":
      return "Waiting for agent";
    case "RefundAccepted":
    case "REFUND_ACCEPTED":
      return "Submit to airline";
    case "SupplierProcessing":
    case "SUPPLIER_PROCESSING":
      return "Waiting on airline";
    case "RefundCompleted":
    case "REFUND_COMPLETED":
    case "Success":
      return "Completed";
    case "Approved":
    case "Pending":
      return "Under Review by Admin";
    case "PendingPayment":
      return "Awaiting Payment";
    case "ChangedOrder":
      return "Reissued";
    case "Paid":
      //   return "Processing";
      return "Paid";
    case "Rejected":
    case "Denied":
      return "Rejected";
    case "Failed":
      return "Failed";
    case "Closed":
      return "Closed";
    default:
      return status;
  }
}

//   Approved = "Approved",
//   Paid = "Paid",
//   Denied = "Denied",
//   Pending = "Pending",
//   PendingPayment = "PendingPayment",
//   PendingVoid = "PendingVoid",
//   PendingRefund = "PendingRefund",
//   Success = "Success",
//   Failed = "Failed",
//   Closed = "Closed",
//   Canceled = "Canceled",
//   AwaitingAdmin = "AwaitingAdmin"
